import { Box, Skeleton, Table, TableBody, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import React from 'react';
import { BaseHead, CellOfRow } from '.';

type Props = {
    itemsRowsLength?: number;
    itemsColumnLength?: number;
};
export default function TableSkeleton(props: Props) {
    return (
        <TableContainer component={Box} sx={{ '& th': { width: `${100 / (props.itemsColumnLength ?? 4)}%` } }}>
            <Table aria-label="simple table">
                <TableHead>
                    <TableRow>
                        {[...new Array(props.itemsColumnLength ?? 4)].map((item, index) => {
                            return (
                                <BaseHead
                                    align={index === 0 ? 'left' : 'center'}
                                    title={<Skeleton variant="text" sx={{ fontSize: '1rem' }} />}
                                />
                            );
                        })}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {[...new Array(props.itemsRowsLength ?? 10)].map((item, index) => {
                        return (
                            <TableRow key={`${index}+1`}>
                                {[...new Array(props.itemsColumnLength ?? 4)].map((item, index) => {
                                    return (
                                        <CellOfRow value={<SkeletonRow />} align={index === 0 ? 'left' : 'center'} />
                                    );
                                })}
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
export const SkeletonRow = () => {
    return <Skeleton variant="text" sx={{ fontSize: '14px' }} />;
};
